/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { CheckBoxInstanceInput } from '../models/CheckBoxInstanceInput';
import type { CheckBoxInstanceLabourInput } from '../models/CheckBoxInstanceLabourInput';
import type { CheckBoxInstancePartInput } from '../models/CheckBoxInstancePartInput';
import type { CheckInstanceType } from '../models/CheckInstanceType';
import type { CheckListDto } from '../models/CheckListDto';
import type { Int32_StringValueTuple } from '../models/Int32_StringValueTuple';
import type { PreparationSummaryModel } from '../models/PreparationSummaryModel';
import type { SendSignatureModelReq } from '../models/SendSignatureModelReq';
import type { UsedVehiclePreparationLookupModel } from '../models/UsedVehiclePreparationLookupModel';
import type { VehiclePreparationCheckTableRespPagedListData } from '../models/VehiclePreparationCheckTableRespPagedListData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { CheckBoxDto } from '../models/CheckBoxDto';

export class VehiclePreparationCheckService {

  /**
   * @param checkListId 
   * @returns PreparationSummaryModel Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklistReportSummary(
checkListId?: number,
): CancelablePromise<PreparationSummaryModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklist/report-summary',
      query: {
        'checkListId': checkListId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param pId 
   * @param cbId 
   * @param clId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteVehiclePreparationChecklistsCheckboxesPart(
pId: number,
cbId: number,
clId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/part/{pId}',
      path: {
        'pId': pId,
        'cbId': cbId,
        'clId': clId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param cbId 
   * @param clId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsCheckboxesPart(
cbId: number,
clId: number,
requestBody?: CheckBoxInstancePartInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/part',
      path: {
        'cbId': cbId,
        'clId': clId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param lId 
   * @param cbId 
   * @param clId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteVehiclePreparationChecklistsCheckboxesLabour(
lId: number,
cbId: number,
clId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/labour/{lId}',
      path: {
        'lId': lId,
        'cbId': cbId,
        'clId': clId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param cbId 
   * @param clId 
   * @param requestBody 
   * @returns number Created
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsCheckboxesLabour(
cbId: number,
clId: number,
requestBody?: CheckBoxInstanceLabourInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}/labour',
      path: {
        'cbId': cbId,
        'clId': clId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param mId 
   * @param clId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteVehiclePreparationChecklistsMedia(
mId: number,
clId: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/vehicle-preparation/checklists/{clId}/media/{mId}',
      path: {
        'mId': mId,
        'clId': clId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param instanceType
 *
 * 0 = CheckBox
 *
 * 1 = GroupInput
   * @param instanceId 
   * @param formData 
   * @returns Int32_StringValueTuple Created
   * @throws ApiError
   */
  public static postVehiclePreparationChecklistsMedia(
id: number,
instanceType: CheckInstanceType,
instanceId: number,
formData?: {
file?: Blob;
},
): CancelablePromise<Int32_StringValueTuple> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{id}/{instanceType}/{instanceId}/media',
      path: {
        'id': id,
        'instanceType': instanceType,
        'instanceId': instanceId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param clId 
   * @param cbId 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static putVehiclePreparationChecklistsCheckboxes(
clId: number,
cbId: number,
requestBody?: CheckBoxInstanceInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-preparation/checklists/{clId}/checkboxes/{cbId}',
      path: {
        'clId': clId,
        'cbId': cbId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns CheckListDto Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklists(
id: number,
): CancelablePromise<CheckListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklists/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @returns number Created
   * @throws ApiError
   */
  public static postVehiclePreparationChecklists(
soHeaderId: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/checklists/{soHeaderId}',
      path: {
        'soHeaderId': soHeaderId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wip 
   * @param branchId
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @returns UsedVehiclePreparationLookupModel Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklistsWipLookup(
wip?: number,
branchId?: BranchType,
): CancelablePromise<UsedVehiclePreparationLookupModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklists/wip-lookup',
      query: {
        'wip': wip,
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param isCompleted 
   * @param isUsed 
   * @param from 
   * @param to 
   * @param branchId
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param regNo 
   * @param paginationSkipPagination Пропустить пагинацию
   * @param paginationPage Страница
   * @param paginationMaxCount Максимально количество записей на странице
   * @returns VehiclePreparationCheckTableRespPagedListData Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklists1(
isCompleted?: boolean,
isUsed?: boolean,
from?: string,
to?: string,
branchId?: BranchType,
regNo?: string,
paginationSkipPagination?: boolean,
paginationPage?: number,
paginationMaxCount?: number,
): CancelablePromise<VehiclePreparationCheckTableRespPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklists',
      query: {
        'IsCompleted': isCompleted,
        'IsUsed': isUsed,
        'From': from,
        'To': to,
        'BranchId': branchId,
        'RegNo': regNo,
        'Pagination.SkipPagination': paginationSkipPagination,
        'Pagination.Page': paginationPage,
        'Pagination.MaxCount': paginationMaxCount,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postVehiclePreparationCheckInSignatures(
id: number,
requestBody?: SendSignatureModelReq,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/vehicle-preparation/check-in/{id}/signatures',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

    /**
   * @param checklistId 
   * @param groupInputInstanceId 
   * @param requestBody 
   * @returns void 
   * @throws ApiError
   */
  public static putVehiclePreparationChecklistsInputs(
checklistId: number,
groupInputInstanceId: number,
requestBody?: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/vehicle-preparation/checklists/{checklistId}/inputs/{groupInputInstanceId}',
      path: {
        'checklistId': checklistId,
        'groupInputInstanceId': groupInputInstanceId,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

    /**
   * @param checkListId 
   * @returns CheckBoxDto Success
   * @throws ApiError
   */
  public static getVehiclePreparationChecklistRepairOrder(
checkListId?: number,
): CancelablePromise<Array<CheckBoxDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/vehicle-preparation/checklist/repair-order',
      query: {
        'checkListId': checkListId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }
}

